<template>
  <Transition name="modal-fade">
    <div class="notification-popup" @click.stop v-if="trigger">
      <div class="orange-exclamation-circle-small" v-if="showExclamation">
        <i class="fa fa-exclamation"></i>
      </div>

      <header class="notification-header">
        <slot name="header"></slot>
      </header>

      <section class="notification-body pt-0">
        <slot name="body"></slot>
      </section>
    </div>
  </Transition>
</template>

<script>
export default {
  name: "AdPopUpModalSmall",
  props: {
    showExclamation: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: "",
    },
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      trigger: false,
    };
  },
  methods: {
    emitClose() {
      this.$emit("close");
    },
    handleEscapeKey(event) {
      if (event.key === "Escape") {
        this.emitClose();
      }
    },
  },
  mounted() {
    this.trigger = true;
    document.addEventListener("keydown", this.handleEscapeKey);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.handleEscapeKey);
  },
};
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.notification-popup {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 350px;
  max-width: 90vw;
  background-color: #d9d9d9;
  border-radius: 10px; /* Rounded edges */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 140;
  overflow: visible;
}

.notification-header {
  background-color: #d9d9d9;
  border-radius: 10px 10px 0 0;
  padding: 1rem;
  position: relative;
}

.notification-body {
  padding: 1rem;
  background-color: #d9d9d9 !important;
  border-radius: 0 0 10px 10px;
}

.notification-footer {
  padding: 0.5rem 1rem;
  background-color: #f5f5f5;
  border-radius: 0 0 10px 10px;
  border-top: 1px solid #dee2e6;
}

.orange-exclamation-circle-small {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 50px;
  background-color: #ff6b35;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
  box-shadow: 0 2px 10px rgba(255, 107, 53, 0.3);
  z-index: 50;
}

.orange-exclamation-circle-small i {
  margin: 0;
  font-size: 30px;
}

/* Close button styling */
.notification-popup .btn-close {
  position: absolute;
  top: 5px;
  right: 5px;
  border: none;
  font-size: 20px;
  padding: 5px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}
</style>
